import { createSlice } from "@reduxjs/toolkit";

const metadataSclice = createSlice({
  name: "metadata",
  initialState: {
    loading: false,
  },
  reducers: {
    metadataRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    metadataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        metadata: action.payload.meta_data,
      };
    },
    metadataFailure(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    getAllMetadataRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    getAllMetadataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        allMetaData: action.payload.getAll,
      };
    },
    getAllMetadataFailure(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    getSingleMetadataRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    getSingleMetadataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        SingleMetaData: action.payload.getSingleMetaData,
      };
    },
    getSingleMetadataFailure(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
    updateMetadataRequest(state, action) {
      return {
        ...state,
        loading: true,
      };
    },
    updateMetadataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        updateMetaData: action.payload.meta_data,
      };
    },
    updateMetadataFailure(state, action) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },
  },
});

const { actions, reducer } = metadataSclice;

export const {
  metadataFailure,
  metadataRequest,
  metadataSuccess,
  getAllMetadataFailure,
  getAllMetadataRequest,
  getAllMetadataSuccess,
  getSingleMetadataFailure,
  getSingleMetadataRequest,
  getSingleMetadataSuccess,
  updateMetadataFailure,
  updateMetadataRequest,
  updateMetadataSuccess,
} = actions;

export default reducer;
